import React from "react";
import Colors from "../../../theme/variables.scss";

const IconWithBackground = (props) => {
  return (
    <span
      className={
        "d-flex align-items-center justify-content-center flex-row " +
        props.className
      }
      style={{
        background: Colors[props.bgcolor],
        color: Colors[props.color],
        width: 41,
        height: 41,
        borderRadius: 10,
        fontSize: 25,
      }}
    >
      <i className={"fa fa-" + props.icon} />
    </span>
  );
};

export default IconWithBackground;
